
<template>
    <v-app id="searchVttk">
        <v-main>
            <v-container fluid>
                <v-card flat>
                    <v-card-title>
                        <v-row>Text translations<v-spacer></v-spacer><v-btn small color="primary" @click="addVttk">add</v-btn></v-row>
                    </v-card-title>
                    <v-row cols="12" no-gutter dense class="ml-2">
                        <v-col cols="3">
                            <v-text-field class="pt-1" dense v-model="search" clearable prepend-icon="mdi-magnify"
                                label="Search through all fields" single-line hide-detail />
                        </v-col>
                    </v-row>
                    <v-data-table :headers="getHeaders()" :must-sort=true :items="searchVttk" :search="search"
                        :disable-pagination=true :loading="loading" :height="wInnerHeight" flat dense fixed-header
                        loading-text="Loading data...please wait" no-data-text="No texts to display" hide-default-footer>
                        <template v-slot:item.vttk_code="{ item }">
                            <span @click="openVttk(item.vttk_encrid)" class="clickable">{{ item.vttk_code }}</span>
                        </template>
                        <template v-slot:item.vttk_created="{ item }">
                            <span>{{ item.vttk_display }}</span>
                        </template>                        
                    </v-data-table>
                </v-card>
            </v-container>
        </v-main>
        <navBar title="Ares - Reference data" :home="true" type="referencedata"/>
        <add_vttk ref="addVttk" @updateData="updateData"/>
    </v-app>
</template>


<script>
import navBar from "@/components/ui/navbars/navbar.vue";
import add_vttk from "@/components/syst/add_vttk.vue";
export default {
    components: {
        navBar,
        add_vttk
    },
    data() {
        return {
            searchVttk: [],
            wInnerHeight: window.innerHeight - 190,
            search:'',
            loading: false,
        }
    },
    destroyed() {
        window.removeEventListener("resize", this.resizeEventHandler);
    },
    created() {
        window.addEventListener("resize", this.resizeEventHandler);
    },
    methods: {
        resizeEventHandler() {
            this.wInnerHeight = window.innerHeight - 190; // deduct estimated height for toolbar, searchfield and headers
        },
        getHeaders() {
            return [
                { text: "ID", value: "vttk_code", sortable: false },
                { text: "Created", value: "vttk_created", sortable: true },
                { text: "Created by", value: "vttk_user", sortable: false, width: '6%'},
                { text: "Context", value: "vttk_oms", sortable: true, width: '20%'},
                { text: "Tekst (EN)", value: "vttk_tekst", sortable: false },
                { text: "NL", value: "vrtk[0].vrtk_vertaling", sortable: false },
                { text: "DE", value: "vrtk[1].vrtk_vertaling", sortable: false },
                { text: "EN", value: "vrtk[2].vrtk_vertaling", sortable: false },
                { text: "FR", value: "vrtk[3].vrtk_vertaling", sortable: false },
            ];
        },
        addVttk(){
            this.$refs.addVttk.open();
        },
        openVttk(encrid){
            let route = this.$router.resolve({ path: `/syst/ref/vttk/onVttk/${encrid}`}); 
            window.open(route.href, '_blank');       
            this.getVttk();
        },
        updateData(data){
            console.log(data);
            data.field==='recid'?this.openVttk(data.value):false;
        },
        getVttk(){
            this.loading = true;
            this.$axios
                .post("ares/json/ares/syst/ref/vttk/searchVttk.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "searchVttk"
                    },
                    searchVttk: {
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.searchVttk = res.data.searchVttk;
                        // console.log(this.searchVttk);
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
    mounted() {
        this.getVttk();
        document.title = "ARES - Text Translations"
    }
};

</script> 

<style scoped>
    .clickable{
        color: blue;
        cursor: pointer;
    }
</style>
